import React, { useState } from "react";
import { toastr } from "react-redux-toastr";
import { Controller, useForm } from "react-hook-form";
import { DropdownList } from "react-widgets";
import ErrorMessage from "../../../../components/text/ErrorMessage";
import {
  Customer,
  Phone,
  EmailAddress,
  District,
  AgeLimit,
  LeadCustomerDetails,
  Designation,
  Divisions,
  Influencer,
} from "../../../../core/api/models";
import CustomerPhone from "../../../../components/customer-phone";
import CustomerEmail from "../../../../components/customer-email";
import DateInput from "../../../../components/form-group/date-input";
import { UploadUserImage } from "../../../../components/upload";
import Countries from "../../../../utils/countries.json";
import title from "../../../../utils/title.json";
import "react-widgets/dist/css/react-widgets.css";
import api from "../../../../api";
import {
  CheckPhoneNumberEmpty,
  ValidateAlphabets,
  ValidateEmail,
  Validate965DigitPhoneNumber,
} from "../../../../utils/Validatation";
import moment from "moment";
import { useDataLoader } from "react-remote-data-hooks";

const ageLimit = [
  { name: "20 - 25" },
  { name: "25 - 30" },
  { name: "30 - 35" },
  { name: "35 - 40" },
  { name: "40 - 45" },
  { name: "45 - 50" },
  { name: "50 - 55" },
  { name: "55 - 60" },
  { name: "60 - 65" },
  { name: "65 - 70" },
  { name: "70 - 75" },
  { name: "75 - 80" },
];

const AddressType = [
  { name: "Home", value: "home" },
  { name: "Work", value: "work" },
];

const EditCompanyUser: React.FunctionComponent<{
  error?: string;
  onCreateCustomer: (data: Customer) => void;
  onCLose?: () => void;
  customerDetails?: Customer;
  phones?: Phone[];
  emails?: EmailAddress[];
  civilId?: string;
  isContact?: boolean;
  parentCompanyCustomer?: Customer;
}> = (props) => {
  const [isAddressSelected, setAddressSelected] = useState<boolean>(false);
  const [isAddressPrimary, setAddressPrimary] = useState<boolean>(false);

  const [isEmailEnable, setIsEmailEnable] = useState<boolean>(true);

  const [isSubmiting, setIsSubmiting] = useState<boolean>(false);

  const [selectedPhone, setSelectedPhone] = useState<Phone[] | undefined>(
    props.customerDetails?.phones
  );
  const [selectedEmail, setSelectedEmail] = useState<
    EmailAddress[] | undefined
  >(props.customerDetails?.emails);
  const {
    control,
    handleSubmit,
    errors,
    clearErrors,
    watch,
    setValue,
  } = useForm<Customer>({
    reValidateMode: "onChange",
    mode: "onSubmit",
  });
  React.useEffect(() => {
    if (watch("dob")) {
      const year = moment().diff(watch("dob"), "years", true);
      const ageRange = AgeLimit?.find((a) => a.from <= year && a.to >= year);
      setValue("ageRange", ageRange?.name);
    }
  }, [watch("dob")]);
  const { data: districtList } = useDataLoader<District[]>(() =>
    api.settings.getDistricts()
  );

  const governorates = [
    ...new Set(districtList?.map((item) => item.governorate)),
  ].sort();

  const governorate = watch("governorate");

  const districts = districtList
    ? !governorate
      ? [...(districtList?.map((item) => item.name) || []), "Other"]
      : [
          ...districtList
            ?.filter((vv) => vv.governorate === governorate)
            ?.map((item) => item.name),
          "Other",
        ] || []
    : [];

  const district = watch("district");

  const { data: influencers } = useDataLoader<Influencer[]>(() =>
    api.influencer.loadAllInfluencer()
  );

  const { data: designations } = useDataLoader<Designation[]>(() =>
    api.designation.loadAllDesignation()
  );
  const setAsPrimary = () => {
    setAddressPrimary(!isAddressPrimary);
  };

  const onSubmit = async (data?: any) => {
    setIsSubmiting(true);
    const updateData: Customer = {
      prefix: data?.prefix,
      firstName: data?.firstName,
      lastName: data?.lastName,
      ageRange: data?.ageRange,
      dob: data?.dob,
      phones: selectedPhone?.filter((x) => CheckPhoneNumberEmpty(x.phone)),
      emails: selectedEmail?.filter((x) => ValidateEmail(x.email)),
      photo: data.photo,
      avatar: data.avatar,
      civilId: data.civilId,
    };
    if (props.isContact && props.parentCompanyCustomer) {
      const {
        _id,
        prefix,
        firstName,
        lastName,
        middleName,
        fullName,
        phone,
        civilId,
        avatar,
      } = props.parentCompanyCustomer;
      const parentCustomerDetails: LeadCustomerDetails = {
        _id: _id!,
        prefix,
        firstName: firstName!,
        lastName,
        middleName,
        fullName,
        phone,
        email: props.parentCompanyCustomer.primaryEmail,
        civilId,
        magicNumber: props.parentCompanyCustomer.identifiers?.magicNumber,
        avatar,
      };
      updateData.parentCompanyCustomer = parentCustomerDetails;
      updateData.influencerId = data.influencerId;
      updateData.designationId = data.designationId;
      updateData.divisionId = data.divisionId;
    }

    if (isAddressSelected && checkAddrsssIsValid(data)) {
      updateData.addresses = [
        {
          houseName: data?.houseName,
          houseNumber: data?.houseNumber,
          address: data?.address,
          unitType: data?.unitType,
          block: data?.block,
          street: data?.street,
          governorate: data?.governorate,
          postalCode: data?.postalCode,
          country: data?.country,
          addressType: data?.addressType?.value,
          isPrimary: isAddressPrimary,
          isOtherDistrict: !!(data.district === "Other"),
          district:
            data?.district === "Other" ? data.otherDistrict : data?.district,
        },
      ];
    }
    try {
      const response = await api.customer.updateCustomer(
        updateData,
        props.customerDetails?._id
      );
      props.onCreateCustomer(response);
      toastr.success("Success", "Customer added successfully");
    } catch (error) {
      toastr.error("Error", error?.response?.data?.message);
    }
    setIsSubmiting(true);
  };

  const checkAddrsssIsValid = (data?: Customer) => {
    return (
      data?.houseName ||
      data?.houseNumber ||
      data?.address ||
      data?.unitType ||
      data?.block ||
      data?.street ||
      data?.governorate ||
      data?.postalCode
    );
  };

  const onChangePhone = (phoneNumber: Phone[]) => {
    setSelectedPhone(phoneNumber);
  };

  const onChangeEmail = (emailAdd: EmailAddress[]) => {
    setSelectedEmail(emailAdd);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="p-4">
        <div className="form-group d-flex flex-wrap align-items-center">
          <Controller
            control={control}
            name="photo"
            render={({ onChange, value, name }) => (
              <UploadUserImage
                id={"photo"}
                title={"Add Photo"}
                onChange={onChange}
              />
            )}
          />
        </div>
        <div className="form-group font-weight-semibold mb-4">
          <label htmlFor="" className="font-sm text-uppercase">
            Title
          </label>
          <Controller
            control={control}
            // rules={{ required: true }}
            name="prefix"
            defaultValue={props.customerDetails?.prefix}
            render={({ onChange, value, name }) => (
              <DropdownList
                value={value}
                defaultValue={value}
                data={title}
                textField={"name"}
                valueField={"name"}
                placeholder={"Select prefix"}
                onChange={(val) => {
                  onChange(val.name);
                }}
              />
            )}
          />
          {errors.prefix && <ErrorMessage>Prefix is required</ErrorMessage>}
        </div>
        <div className="form-group font-weight-semibold mb-4">
          <label htmlFor="" className="font-sm text-uppercase">
            First Name<span className="text-danger">*</span>
          </label>

          <Controller
            control={control}
            defaultValue={props?.customerDetails?.firstName}
            rules={{
              required: true,
              validate: (value) => {
                return !!ValidateAlphabets(value);
              },
              maxLength: 25,
            }}
            name="firstName"
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="First Name"
                name={name}
                value={value}
                onChange={onChange}
                id="firstName"
              />
            )}
          />
          {errors.firstName && errors.firstName.type === "required" && (
            <ErrorMessage>First Name is required</ErrorMessage>
          )}
          {errors.firstName && errors.firstName.type === "maxLength" && (
            <ErrorMessage>
              First name should contains maximum 25 characters
            </ErrorMessage>
          )}
          {errors.firstName && errors.firstName.type === "validate" && (
            <ErrorMessage>Invalid First Name</ErrorMessage>
          )}
        </div>
        <div className="form-group font-weight-semibold mb-4">
          <label htmlFor="" className="font-sm text-uppercase">
            Last Name<span className="text-danger">*</span>
          </label>
          <Controller
            control={control}
            defaultValue={props?.customerDetails?.lastName}
            rules={{
              required: true,
              validate: (value) => {
                return !!ValidateAlphabets(value);
              },
              maxLength: 25,
            }}
            name="lastName"
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Last Name"
                name={name}
                value={value}
                onChange={onChange}
                id="lastName"
              />
            )}
          />
          {errors.lastName && errors.lastName.type === "required" && (
            <ErrorMessage>Last Name is required</ErrorMessage>
          )}
          {errors.lastName && errors.lastName.type === "maxLength" && (
            <ErrorMessage>
              Last name should contains maximum 25 characters
            </ErrorMessage>
          )}
          {errors.lastName && errors.lastName.type === "validate" && (
            <ErrorMessage>Invalid Last Name</ErrorMessage>
          )}
        </div>
        <div className="form-group font-weight-semibold mb-4">
          <label htmlFor="" className="font-sm text-uppercase">
            Phone<span className="text-danger">*</span>
          </label>

          <Controller
            control={control}
            rules={{
              required: true,
              validate: (value) => {
                return !(
                  !selectedPhone ||
                  (selectedPhone &&
                    selectedPhone?.filter((x) =>
                      Validate965DigitPhoneNumber(x.phone)
                    ).length !== selectedPhone?.length)
                );
              },
            }}
            name="phones"
            defaultValue={props.customerDetails?.phones}
            render={({ onChange, value, name }) => (
              <CustomerPhone
                className="form-control p-0 rounded-sm font-weight-semibold"
                placeholder="Phone"
                value={selectedPhone}
                onChange={(val) => {
                  onChangePhone(val);
                  onChange(val);
                }}
              />
            )}
          />
          {errors.phones && (
            <div>
              <div>
                {!selectedPhone ? (
                  <ErrorMessage>Valid Phone is required</ErrorMessage>
                ) : (
                  <>
                    {selectedPhone?.filter(
                      (x) =>
                        !!(
                          x.phone.startsWith("91") || x.phone.startsWith("+91")
                        )
                    ).length > 0 ? (
                      <ErrorMessage>
                        Phone number should be 8 digits
                      </ErrorMessage>
                    ) : (
                      <ErrorMessage>Invalid Phone number</ErrorMessage>
                    )}
                  </>
                )}
              </div>
            </div>
          )}
        </div>
        <div className="form-group font-weight-semibold mb-4">
          <label
            htmlFor=""
            className="font-sm text-uppercase d-flex align-items-end"
          >
            Email
            <div className="ml-auto switch switch--sm">
              <input
                type="checkbox"
                name=""
                onChange={(val) => {
                  setIsEmailEnable(!isEmailEnable);
                  if (isEmailEnable) {
                    clearErrors("emails");
                  }
                }}
                id="emailSwitch"
                checked={isEmailEnable}
              />
              <label htmlFor="emailSwitch">
                <div className="switch-handle mr-2"></div>
              </label>
            </div>
          </label>
          <Controller
            control={control}
            rules={{
              required:
                (!selectedEmail ||
                  (selectedEmail &&
                    selectedEmail?.filter((x) => ValidateEmail(x.email))
                      .length === 0)) &&
                isEmailEnable,
            }}
            name="emails"
            defaultValue={props?.customerDetails?.emails}
            render={({ onChange, value, name }) => (
              <CustomerEmail
                className="form-control p-0 rounded-sm font-weight-semibold"
                placeholder="Email"
                value={selectedEmail}
                onChange={onChangeEmail}
                disabled={!isEmailEnable}
              />
            )}
          />
          {errors.emails && (
            <div>
              <ErrorMessage>Valid email is required</ErrorMessage>
            </div>
          )}
        </div>
        <div className="form-group font-weight-semibold mb-4">
          <label htmlFor="" className="font-sm text-uppercase">
            Date Of Birth
          </label>
          <Controller
            control={control}
            name="dob"
            defaultValue={props?.customerDetails?.dob}
            render={({ onChange, value, name }) => (
              <DateInput
                default={value}
                placeholder={"Date Of Birth"}
                onChange={onChange}
                maxDate={new Date()}
              />
            )}
          />
          {errors.dob && <ErrorMessage>Date of birth is required</ErrorMessage>}
        </div>
        <div className="form-group font-weight-semibold mb-4">
          <label htmlFor="" className="font-sm text-uppercase">
            Age Limit
          </label>
          <Controller
            control={control}
            defaultValue={props?.customerDetails?.ageRange}
            name="ageRange"
            render={({ onChange, value, name }) => (
              <DropdownList
                value={value}
                defaultValue={value}
                data={AgeLimit}
                textField={"name"}
                valueField={"name"}
                placeholder={"Select Age Limit"}
                onChange={(val) => {
                  onChange(val.name);
                }}
              />
            )}
          />
          {errors.ageRange && (
            <ErrorMessage>Age limit is required</ErrorMessage>
          )}
        </div>

        {props.isContact && (
          <>
            {" "}
            <div className="form-group font-weight-semibold mb-4">
              <label htmlFor="" className="font-sm text-uppercase">
                Influencer<span className="text-danger">*</span>
              </label>
              <Controller
                control={control}
                name="influencerId"
                rules={{ required: true }}
                defaultValue={props?.customerDetails?.influencer?._id}
                render={({ onChange, value, name }) => (
                  <DropdownList
                    value={value}
                    defaultValue={value}
                    data={influencers?.map((key) => {
                      return {
                        _id: key._id,
                        name: key.name,
                      };
                    })}
                    textField={"name"}
                    valueField={"_id"}
                    placeholder={"Select Influencer"}
                    onChange={(val) => {
                      onChange(val._id);
                    }}
                  />
                )}
              />
              {errors.influencerId && (
                <ErrorMessage>Influencer is required</ErrorMessage>
              )}
            </div>
            <div className="form-group font-weight-semibold mb-4">
              <label htmlFor="" className="font-sm text-uppercase">
                Designation<span className="text-danger">*</span>
              </label>
              <Controller
                control={control}
                rules={{ required: true }}
                name="designationId"
                defaultValue={props?.customerDetails?.designation?._id}
                render={({ onChange, value, name }) => (
                  <DropdownList
                    value={value}
                    filter="contains"
                    defaultValue={value}
                    data={designations?.map((key) => {
                      return {
                        _id: key._id,
                        name: key.name,
                      };
                    })}
                    textField={"name"}
                    valueField={"_id"}
                    placeholder={"Select Designation"}
                    onChange={(val) => {
                      onChange(val._id);
                    }}
                  />
                )}
              />
              {errors.designationId && (
                <ErrorMessage>Designation is required</ErrorMessage>
              )}
            </div>
          </>
        )}
        <div className="mb-4">
          <h5 className="text-uppercase font-weight-semibold mb-2">Address</h5>
          {!isAddressSelected && (
            <button
              type="button"
              className="btn btn-link font-sm p-0 font-weight-semibold"
              onClick={() => setAddressSelected(true)}
            >
              + add address
            </button>
          )}
        </div>
        {isAddressSelected && (
          <div>
            <div className="form-group font-weight-semibold mb-4">
              <label htmlFor="" className="font-sm text-uppercase">
                House Name
              </label>
              <Controller
                control={control}
                defaultValue={props?.customerDetails?.houseName}
                // rules={{ required: isAddressSelected }}
                name="houseName"
                render={({ onChange, value, name }) => (
                  <input
                    type="text"
                    className="form-control rounded-sm font-weight-semibold"
                    placeholder="House Name"
                    name={name}
                    value={value}
                    onChange={onChange}
                    id="houseName"
                  />
                )}
              />
              {errors.houseName && (
                <ErrorMessage>
                  {errors.houseName.type === "required"
                    ? "House Name is required"
                    : "Invalid House Name"}
                </ErrorMessage>
              )}
            </div>
            <div className="form-group font-weight-semibold mb-4">
              <label htmlFor="" className="font-sm text-uppercase">
                House Number
              </label>
              <Controller
                control={control}
                defaultValue={props?.customerDetails?.houseNumber}
                rules={{
                  required: isAddressSelected,
                  validate: (value) => {
                    return !!value.trim();
                  },
                }}
                name="houseNumber"
                render={({ onChange, value, name }) => (
                  <input
                    type="text"
                    className="form-control rounded-sm font-weight-semibold"
                    placeholder="House Number"
                    name={name}
                    value={value}
                    onChange={onChange}
                    id="houseNumber"
                  />
                )}
              />
              {errors.houseNumber && (
                <ErrorMessage>
                  {errors.houseNumber.type === "required"
                    ? "House Number is required"
                    : "Invalid House Number"}
                </ErrorMessage>
              )}
            </div>
            <div className="form-group font-weight-semibold mb-4">
              <label htmlFor="" className="font-sm text-uppercase">
                Building Address
              </label>
              <Controller
                control={control}
                rules={{
                  required: isAddressSelected,
                  validate: (value) => {
                    return !!value.trim();
                  },
                }}
                name="address"
                defaultValue={props.customerDetails?.address}
                render={({ onChange, value, name }) => (
                  <input
                    type="text"
                    className="form-control rounded-sm font-weight-semibold"
                    placeholder="Building Address"
                    name={name}
                    value={value}
                    onChange={onChange}
                    id="address"
                  />
                )}
              />
              {errors.address && (
                <ErrorMessage>
                  {errors.address.type === "required"
                    ? "Building Address is required"
                    : "Invalid Building Address"}
                </ErrorMessage>
              )}
            </div>
            <div className="form-group font-weight-semibold mb-4">
              <label htmlFor="" className="font-sm text-uppercase">
                Unit Type
              </label>
              <Controller
                control={control}
                defaultValue={props?.customerDetails?.unitType}
                name="unitType"
                render={({ onChange, value, name }) => (
                  <input
                    type="text"
                    className="form-control rounded-sm font-weight-semibold"
                    placeholder="Unit Type"
                    name={name}
                    value={value}
                    onChange={onChange}
                    id="unitType"
                  />
                )}
              />
              {errors.unitType && (
                <ErrorMessage>
                  {errors.unitType.type === "required"
                    ? "Unit Type is required"
                    : "Invalid Unit Type"}
                </ErrorMessage>
              )}
            </div>
            <div className="form-group font-weight-semibold mb-4">
              <label htmlFor="" className="font-sm text-uppercase">
                Block
              </label>
              <Controller
                control={control}
                defaultValue={props?.customerDetails?.block}
                rules={{
                  required: isAddressSelected,
                  validate: (value) => {
                    return !!value.trim();
                  },
                }}
                name="block"
                render={({ onChange, value, name }) => (
                  <input
                    type="text"
                    className="form-control rounded-sm font-weight-semibold"
                    placeholder="Block"
                    name={name}
                    value={value}
                    onChange={onChange}
                    id="block"
                  />
                )}
              />
              {errors.block && (
                <ErrorMessage>
                  {errors.block.type === "required"
                    ? "Block is required"
                    : "Invalid Block"}
                </ErrorMessage>
              )}
            </div>
            <div className="form-group font-weight-semibold mb-4">
              <label htmlFor="" className="font-sm text-uppercase">
                Street
              </label>
              <Controller
                control={control}
                defaultValue={props?.customerDetails?.street}
                rules={{
                  required: isAddressSelected,
                  validate: (value) => {
                    return !!value.trim();
                  },
                }}
                name="street"
                render={({ onChange, value, name }) => (
                  <input
                    type="text"
                    className="form-control rounded-sm font-weight-semibold"
                    placeholder="Street"
                    name={name}
                    value={value}
                    onChange={onChange}
                    id="street"
                  />
                )}
              />
              {errors.street && (
                <ErrorMessage>
                  {errors.street.type === "required"
                    ? "Street is required"
                    : "Invalid Street"}
                </ErrorMessage>
              )}
            </div>

            <div className="form-group font-weight-semibold mb-4">
              <label htmlFor="" className="font-sm text-uppercase">
                Governorate
              </label>
              <Controller
                control={control}
                rules={{ required: isAddressSelected }}
                defaultValue={props?.customerDetails?.governorate}
                name="governorate"
                render={({ onChange, value, name }) => (
                  <DropdownList
                    value={value}
                    defaultValue={value}
                    data={governorates?.map((key) => {
                      return {
                        name: key,
                      };
                    })}
                    textField={"name"}
                    valueField={"name"}
                    placeholder={"Select Governorate"}
                    onChange={(val) => {
                      onChange(val.name);
                      setValue("district", "");
                      setValue("otherDistrict", "");
                    }}
                  />
                )}
              />
              {errors.governorate && (
                <ErrorMessage>
                  {errors.governorate.type === "required"
                    ? "Governorate is required"
                    : "Invalid Governorate"}
                </ErrorMessage>
              )}
            </div>
            <div className="form-group font-weight-semibold mb-4">
              <label htmlFor="" className="font-sm text-uppercase">
                District
              </label>
              <Controller
                control={control}
                rules={{ required: isAddressSelected }}
                defaultValue={props?.customerDetails?.district}
                name="district"
                render={({ onChange, value, name }) => (
                  <DropdownList
                    value={value}
                    defaultValue={value}
                    data={districts?.map((key) => {
                      return {
                        name: key,
                      };
                    })}
                    textField={"name"}
                    valueField={"name"}
                    placeholder={"Select District"}
                    onChange={(val) => {
                      onChange(val.name);
                      setValue("otherDistrict", "");
                    }}
                  />
                )}
              />
              {errors.district && (
                <ErrorMessage>
                  {errors.district.type === "required"
                    ? "District is required"
                    : "Invalid District"}
                </ErrorMessage>
              )}
            </div>
            {district === "Other" && (
              <div className="form-group font-weight-semibold mb-4">
                <label htmlFor="" className="font-sm text-uppercase"></label>
                <Controller
                  control={control}
                  name="otherDistrict"
                  defaultValue={props?.customerDetails?.otherDistrict}
                  render={({ onChange, value, name }) => (
                    <input
                      type="text"
                      className="form-control rounded-sm font-weight-semibold"
                      placeholder="Enter District"
                      name={name}
                      value={value}
                      onChange={onChange}
                      id="otherDistrict"
                    />
                  )}
                />
                {errors.district && (
                  <ErrorMessage>
                    {errors.district.type === "required"
                      ? "District is required"
                      : "Invalid District"}
                  </ErrorMessage>
                )}
              </div>
            )}
            <div className="form-group font-weight-semibold mb-4">
              <label htmlFor="" className="font-sm text-uppercase">
                Postal Code
              </label>
              <Controller
                control={control}
                // rules={{ required: isAddressSelected }}
                defaultValue={props?.customerDetails?.postalCode}
                name="postalCode"
                render={({ onChange, value, name }) => (
                  <input
                    type="text"
                    className="form-control rounded-sm font-weight-semibold"
                    placeholder="Postal Code"
                    name={name}
                    value={value}
                    onChange={onChange}
                    id="postalCode"
                  />
                )}
              />
              {errors.postalCode && (
                <ErrorMessage>
                  {errors.postalCode.type === "required"
                    ? "Postal Code is required"
                    : "Invalid Postal Code"}
                </ErrorMessage>
              )}
            </div>
            <div className="form-group font-weight-semibold mb-4">
              <label htmlFor="" className="font-sm text-uppercase">
                Country
              </label>
              <Controller
                control={control}
                name="country"
                defaultValue={props?.customerDetails?.country}
                render={({ onChange, value, name }) => (
                  <DropdownList
                    value={value}
                    defaultValue={value}
                    data={Countries}
                    textField={"name"}
                    valueField={"name"}
                    placeholder={"Select country"}
                    onChange={(val) => {
                      onChange(val.name);
                    }}
                    filter={"contains"}
                  />
                )}
              />
              {errors.country && (
                <ErrorMessage>
                  {errors.country.type === "required"
                    ? "Country is required"
                    : "Invalid Country"}
                </ErrorMessage>
              )}
            </div>
            {/* <div className="form-group font-weight-semibold mb-4">
              <label htmlFor="" className="font-sm text-uppercase">
                PACI Number
              </label>
              <Controller
                control={control}
                // rules={{ required: true }}
                name="paciNumber"
                defaultValue={props.customerDetails?.paciNumber}
                render={({ onChange, value, name }) => (
                  <input
                    type="text"
                    className="form-control rounded-sm font-weight-semibold"
                    placeholder="PACI Number"
                    name={name}
                    value={value}
                    onChange={onChange}
                    id="paciNumber"
                  />
                )}
              />
              {errors.paciNumber && (
                <ErrorMessage>
                  {errors.paciNumber.type === 'required'
                    ? 'PACI Number is required'
                    : 'Invalid PACI Number'}
                </ErrorMessage>
              )}
            </div> */}
          </div>
        )}
        <div className="form-group pt-2">
          <button
            disabled={isSubmiting}
            className="btn btn-primary btn-block font-normal font-weight-bold"
          >
            Edit Contact
          </button>
        </div>
        {props.onCLose && (
          <button
            type="button"
            onClick={() => props.onCLose?.()}
            className="btn btn-outline-dark btn-block font-normal font-weight-bold btn-goback text-gray-500 mb-2"
          >
            Go Back
          </button>
        )}
      </div>
    </form>
  );
};

export default EditCompanyUser;
